<template>
  <div class="common-box">
    <el-form
      inline
      ref="form"
      class="search-form common-box-search-form"
      label-position="right"
      :model="form"
      label-width="70px"
    >
      <search-form @search="handleSearch" @refresh="handleRefresh">
        <div slot="content">
          <el-form-item label="模板名称：">
            <el-input
              @change="handleSearchListData"
              size="mini"
              v-model.trim="form.templateName"
              placeholder="请输入模板名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="电梯类型：">
            <el-select
              size="mini"
              v-model="form.liftTypeCode"
              placeholder="请选择电梯类型"
              clearable
              filterable
              @change="handleSearchListData"
            >
              <el-option
                v-for="item in dtlxDicts"
                :key="item.dictionaryCode"
                :label="item.dictionaryValue"
                :value="item.dictionaryCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </search-form>
    </el-form>
    <div class="common-cover-div"></div>
    <div class="operation-and-table__container">
      <div class="btns__container">
        <el-button
          v-if="hasRole['GZLXMBTJ']"
          size="mini"
          type="primary"
          class="plr28"
          @click="handleAdd"
        >添加</el-button>
        <el-button
          size="mini"
          type="primary"
          class="plr28"
          @click="handleDelete"
          plain
          v-if="hasRole['GZLXMBSC']"
        >删除</el-button>
      </div>
      <div class="table__container">
        <el-table
          v-loading="tableLoading"
          :data="list"
          height="100%"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column type="index" label="序号" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="templateName" label="模板名称" width="260"></el-table-column>
          <el-table-column show-overflow-tooltip prop="liftTypeName" label="电梯类型" width="100"></el-table-column>
          <el-table-column show-overflow-tooltip prop="createTime" label="添加时间" width="100">
            <template slot-scope="scope">
              {{scope.row.createTime ? scope.row.createTime.slice(0, 10) : ''}}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="remark" label="备注信息"></el-table-column>
          <el-table-column label=" " prop=" "></el-table-column>
          <el-table-column label="操作" width="225px" fixed="right">
            <template slot-scope="scope">
              <el-button
                size="mini"
                v-if="hasRole['GZLX']"
                type="text"
                @click="jumpFaultTypesItems(scope.row)"
              >故障点</el-button>
              <div class="btn-divide" v-if="hasRole['GZLX']"></div>
              <el-button
                size="mini"
                v-if="hasRole['GZLXMBBJ']"
                type="text"
                @click="handleEdit(scope.row)"
              >编辑</el-button>
              <div class="btn-divide" v-if="hasRole['GZLXMBBJ']"></div>
              <el-button
                size="mini"
                v-if="hasRole['GZLXMBFZ']"
                type="text"
                @click="handleEditCopy(scope.row)"
              >复制</el-button>
              <div class="btn-divide" v-if="hasRole['GZLXMBFZ']"></div>
              <el-button
                size="mini"
                v-if="hasRole['GZLXMBSC']"
                type="text"
                @click="handleDeleteTemplate(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagenation__container">
        <div class="for-fff-bg">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[25, 50, 100, 150, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <add-template
      v-if="addTemplateVisible"
      @cancel="addTemplateVisible = false"
      @confirm="handleAddTemplateConfirm"
    ></add-template>
    <edit-template
      v-if="editTemplateVisible"
      :editData="templateDetail"
      @cancel="editTemplateVisible = false"
      @confirm="handleEditTemplateConfirm"
    ></edit-template>
  </div>
</template>

<script>

import {
  getPointTemplateList,
  deleteTemplate
} from "@/api/FaultTypesTemplate";

import AddTemplate from "./components/AddTemplate";
import EditTemplate from "./components/EditTemplate";

import { mapState } from "vuex";
export default {
  name: "FaultTypesTemplate",
  components: {
    AddTemplate,
    EditTemplate,
  },
  data() {
    return {
      form: {
        templateName: "",
        liftTypeCode: "",
      },
      tableLoading: false,
      list: [],
      multipleSelection: [],
      pageIndex: 1,
      pageSize: 50,
      total: 0,
      addTemplateVisible: false,
      editTemplateVisible: false,
      checkTemplateVisible: false,
      templateDetail: {},
    };
  },
  computed: {
    hasRole: function () {
      return this.$store.getters["common/promise/getRole"](this.$route.path);
    },
    ...mapState("common/dictionary", ["dtlxDicts"]),
  },
  created() {
    this.getListData();
  },
  methods: {
    async getListData() {
      this.tableLoading = true;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let key in this.form) {
        if (this.form[key]) params[key] = this.form[key];
      }
      const res = await getPointTemplateList(params);
      if (res.code === 200) {
        this.total = res.data.total;
        this.list = res.data.list;
      }
      this.tableLoading = false;
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleRefresh() {
      for (let key in this.form) {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      }
      this.pageIndex = 1;
      this.getListData();
    },
    handleSearchListData() {
      this.pageIndex = 1;
      this.getListData();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDeleteTemplate(row) {
      const idList = [row.id];
      this.deleteTemplate(idList);
    },

    handleEdit(row) {
      this.templateDetail = row;
      this.editTemplateVisible = true;
    },
    handleEditCopy(row) {
      this.templateDetail = {...row};
      this.templateDetail.copy = true
      this.templateDetail.templateName = ''
      this.editTemplateVisible = true;
    },
    handleDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning("请选择要删除的行");
        return;
      }
      const idList = this.multipleSelection.map((item) => item.id);
      this.deleteTemplate(idList);
    },
    deleteTemplate(idList) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteTemplate({ idList });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getListData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleAdd() {
      this.addTemplateVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getListData();
    },
    handleAddTemplateConfirm() {
      this.addTemplateVisible = false;
      this.pageIndex = 1;
      this.getListData();
    },
    handleEditTemplateConfirm() {
      this.editTemplateVisible = false;
      this.getListData();
    },
    jumpFaultTypesItems(row) {
      this.$router.push({
        name: 'FaultTypesItems',
        query: {
          templateId: row.id
        }
      })
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/FaultTypesTemplate/FaultTypesTemplate.vue